import { FC } from 'react';
import { ColorManager } from 'components/UI/V3/ColorManager/ColorManager';
import { Label } from 'components/UI/V3/Forms/Label/Label';
import DescriptionText from 'components/UI/V3/DescriptionText/DescriptionText';
import styles from './ColorCodeSection.module.scss';

interface ColorCodeSectionProps {
    className?: string;
    color: string | null;
    onChange: (color: string | null) => void;
}

export const ColorCodeSection: FC<ColorCodeSectionProps> = ({ color, onChange, className }) => {
    return (
        <div className={`${styles.colorSection} ${className || ''}`}>
            <div className={styles.colorLabelContainer}>
                <Label>Color Code</Label>
                <DescriptionText text="Select a color to identify this service." />
            </div>
            <ColorManager
                color={color}
                onChange={onChange}
                className={styles.colorManager}
            />
        </div>
    );
};
